import { Place } from 'wdc-cube'

export const ParamIds = {
    compliance: 'compliance',
    resetPassword: 'rpwd',
    changePassword: 'cpwd',
    changePasswordToken: 'rtoken',
    companyIds: 'companyIds',
    partnerIds: 'partnerId',
    personIds: 'personIds',
    tmRequestGroupId: 'tmgrid',
    tmMarkCacheId: 'tmmdci',
    tmListingTab: 'tmlsttb',
    tcmFilterFormMode: 'tcmffm',
    tcmFilterSourceId: 'tcmfsrc',
    tcListingTab: 'tclsttb',
    taSelectedCard: 'tasc',
    mvTab: 'mvtab',
    microsoftLoginCode: 'microsoftCode',
    googleLoginCode: 'googleCode',
    userId: 'usmId',
    userFilter: 'usmFltr',
    groupId: 'gsmId',
    groupFilter: 'gsmFltr',
    profileStMoFilter: 'uspfFltsm',
    profileEnMoFilter: 'uspfFltem',
    profilePageFilter: 'uspfFltpg',
    profileLimitFilter: 'uspfFltlmt',
    configListingTabs: 'cfglsttb',
    groupProfileId: 'gPrfId',
    groupProfileStMoFilter: 'gPrfFltsm',
    groupProfileEnMoFilter: 'gPrfFltem',
    groupProfilePageFilter: 'gPrfFltpg',
    groupProfileLimitFilter: 'gPrfFltlmt',
    groupProfileOrigin: 'gPrfOrigin',
    userPassChangeOrigin: 'uPasChgOrigin',
    accessAuditStart: 'aaSt',
    accessAuditEnd: 'aaEn',
    accessAuditGroup: 'aaGrp',
    accessAuditUser: 'aaUsr',
    accessAuditPage: 'aaPg',
    billingStart: 'blSt',
    billingEnd: 'blEn',
    billingGroup: 'blGrp',
    billingMonth: 'blMes',
    billingOnlyExceeded: 'blExc',

    // :: Motor de Crédito
    mcGrupoFormId: 'gfrmid',
    mcMonitoramentoFormId: 'mfrmid',
    mcAnaliseFormId: 'afrmid',
    mcAnaliseSelectId: 'asrmid',
    mcRegraFormId: 'rfrmid',
    mcCondicaoFormId: 'cfrmid',
    mcBorderoFormId: 'bdfrmid',
    mcBorderoStatusProcId: 'bspdfrmid',
    mcResultadoShowOrigem: 'bdfrmresor',
    mcResultadoShowIdOrigem: 'bdfrmresorid',
    mcResultadoShowIdSacado: 'bdfrmressaid',
    mcResultVisaoCedenteId: 'rvcfrmid',
    mcBorderoFiltroDataInicial: 'blfdi',
    mcBorderoFiltroDataFinal: 'blfdf',
    mcBorderoFiltroStatus: 'blfs',
    mcBorderoFiltroCodBordero: 'blfcb',
    mcSerasaHistoryStartDate: 'shsd',
    mcSerasaHistoryEndDate: 'shed',
    mcSerasaHistoryStatus: 'shst',
    mcSerasaHistoryEndpoint: 'shep'
}

export const AttrIds = {
    parentSlot: 'parent-slot',
    dialogSlot: 'sialog-slot',

    subscriptionsDetail_item: '0001',

    // :: Motor de Crédito
    mcNewNpCondicaoAttr: 'new-np-condicao-attr'
}

export const Places = {
    main: Place.ROOT,
    overview: Place.UNKNOWN,
    profile: Place.UNKNOWN,
    groupProfile: Place.UNKNOWN,
    theConnection: Place.UNKNOWN,
    theMap: Place.UNKNOWN,
    theMapMarkDetail: Place.UNKNOWN,
    theActing: Place.UNKNOWN,
    theConsumerMarket: Place.UNKNOWN,
    theConsumerMarket_FilterCatalogForm: Place.UNKNOWN,
    theConsumerMarket_FilterCatalogShare: Place.UNKNOWN,
    mercadoVet: Place.UNKNOWN,
    mercadoVet_FilterCatalogForm: Place.UNKNOWN,
    mercadoVet_FilterCatalogShare: Place.UNKNOWN,
    analiseDesempenho: Place.UNKNOWN,
    analiseDesempenho_FilterCatalogForm: Place.UNKNOWN,
    analiseDesempenho_FilterCatalogShare: Place.UNKNOWN,
    rdStation: Place.UNKNOWN,
    userManager: Place.UNKNOWN,
    userManagerForm: Place.UNKNOWN,
    userChangePasswordForm: Place.UNKNOWN,
    groupManager: Place.UNKNOWN,
    groupManagerForm: Place.UNKNOWN,
    configurations: Place.UNKNOWN,
    accessAudit: Place.UNKNOWN,
    billing: Place.UNKNOWN,
    restricted: Place.UNKNOWN,

    // :: Motor de Crédito
    mcPf: Place.UNKNOWN,
    mcPj: Place.UNKNOWN,
    mcSerasa: Place.UNKNOWN,
    mcSerasaHistory: Place.UNKNOWN,
    mcSerpro: Place.UNKNOWN,
    mcGrupo: Place.UNKNOWN,
    mcGrupoForm: Place.UNKNOWN,
    mcAnalise: Place.UNKNOWN,
    mcAnaliseForm: Place.UNKNOWN,
    mcAnaliseSelect: Place.UNKNOWN,
    mcRegraForm: Place.UNKNOWN,
    mcCondicaoForm: Place.UNKNOWN,
    mcBordero: Place.UNKNOWN,
    mcBorderoForm: Place.UNKNOWN,
    mcStatusProcessamentoBordero: Place.UNKNOWN,
    mcResultadoAnalise: Place.UNKNOWN,
    mcResultadoDetalhadoAnalise: Place.UNKNOWN,
    mcDialogoResultadoDetalhadoAnalise: Place.UNKNOWN,
    mcIntegracaoMonitoramento: Place.UNKNOWN,
    mcIntegracaoMonitoramentoForm: Place.UNKNOWN,
    mcResultadoAnaliseVisaoCedente: Place.UNKNOWN
}

export const PlaceLabels: Record<string, string> = {
    overview: 'Início',
    theConsumerMarket: 'Mercado IA',
    mercadoVet: 'Mercado Veterinário',
    analiseDesempenho: 'Análise de Desempenho',
    theConnection: 'Relações Societárias',
    theActing: 'Profissionais Médicos',
    theMap: 'The Map',
    rdStation: 'RD Station',
    userProfile: 'Perfil do Usuário',
    groupProfile: 'Perfil do Grupo',
    userManager: 'Gerenciar Usuários',
    groupManager: 'Gerenciar Grupos',
    changePasswordForm: 'Alterar Senha',
    configurations: 'Configurações',
    accessAudit: 'Auditoria de Acesso',
    billing: 'Faturamento',
    restricted: 'Acesso Restrito',

    // :: Motor de Crédito
    mcPj: 'Pessoa Jurídica',
    mcPf: 'Pessoa Física',
    mcSerasa: 'Serasa',
    mcSerasaHistory: 'Histórico Serasa',
    mcSerpro: 'NF-e / SERPRO',
    mcGrupo: 'Grupos de Análise',
    mcAnalise: 'Análises',
    mcBordero: 'Borderôs',
    mcIntegracaoMonitoramento: 'Documentos Monitorados'
}
